/** 将后台返回的文件路径转为前端可用的完整 URL（相对路径补全前缀） */
export function resolveFileUrl(url) {
  if (!url) return ''
  if (/^https?:\/\//i.test(url) || url.startsWith('data:')) return url
  return url.startsWith('/') ? url : `/${url}`
}

export const resolveVideoUrl = resolveFileUrl
